import { Location } from './class/location.js';

(($) => {

  const ctrl = {
    locations:[],
    requests:0,
    now:new Date(),
    view: {
      parent: document.querySelector(".component-national-map")
    },
    localRetrieve:function(collection) {
      const item = localStorage.getItem(collection);
      if (item) {
        const data = JSON.parse(item);
        if (data.expiry > this.now) {
          return data.value;
        }
      }
      return undefined;
    },
    localStore:function(collection,data) {
      const item = {
        value: data,
        expiry: this.now.getTime() + 86400000, //ttl = 1 day
      }
      localStorage.setItem(collection, JSON.stringify(item));
    },
    setProcessing:function(on) {
      const cl = this.view.parent.classList;
      if (on) {
        cl.add("processing");
      } else {
        cl.remove("processing");
      }
    },
    setLocations:function(locations) {
      //Sort so that parents will get initialized before children
      this.locations = locations.sort((a,b) => {
        if(a.acf.parent_location && !b.acf.parent_location) return 1;
        if(!a.acf.parent_location && b.acf.parent_location) return -1;
        return 0;
      })
      this.locations.forEach((loc,l) => {
        this.locations[l] = new Location(loc,this);
      })
      this.resolveLocationConflicts();
      let stateLocations = this.locations.filter(loc => !loc.local && loc.model.title.rendered !== "National");
      stateLocations = stateLocations.sort((a,b) => {
        if (a.model.title.rendered < b.model.title.rendered) return -1;
        if (a.model.title.rendered > b.model.title.rendered) return 1;
        return 0;
      });
      const locations_list = this.view.mobile.querySelector(".list-locations");
      this.renderMobileList(stateLocations,locations_list);
      locations_list.addEventListener("change",(e) => {
        if (e.target.value) {
          const target = this.locations.find(l => l.model.id == e.target.value);
          if (target) target.setState("active",true);
        }
      });
    },
    resolveLocationConflicts:function() {
      this.locations.forEach(loc => {
        loc.associateChildren();
        loc.deconflict(this.locations);
      })
    },
    renderMobileList:function(locations,list) {
      locations.filter(loc => loc.has_issues).forEach(loc => {
        const option = document.createElement("option");
        option.innerHTML = loc.local ? "&emsp;" + loc.model.title.rendered : loc.model.title.rendered;
        option.value = loc.model.id;
        // if (loc.state.past) option.classList.add("past");
        // if (loc.state.current) option.classList.add("current");
        list.appendChild(option);
        // if (loc.children && loc.children.length) {
        //   this.renderMobileList(loc.children,list);
        // }
      })
    },
    initView:function() {
      this.view.map = this.view.parent.querySelector(".map__map [class*=col-]");
      this.view.svg = this.view.map.querySelector("svg");
      this.view.states = this.view.svg.querySelector("#states");
      this.view.locals = this.view.svg.querySelector("#locals");
      this.view.content = this.view.parent.querySelector(".map__related [class*=col-]");
      this.view.mobile = this.view.parent.querySelector(".map__mobile [class*=col-]"); 
    },
    init:function(locations) {
      this.initView();
      this.setLocations(locations);
      this.setProcessing(false);
    },
    fetchCollection: function(collection) {
      return new Promise((resolve,reject) => {
        const local = this.localRetrieve(collection);
        if (local) {
          resolve(local);
        } else {
          $.get(`/wp-json/wp/v2/${collection}?per_page=1000`,
            {},
            (res) => {
              resolve(res);
            }
          )
        }
      })
    },
    fetch:function() {
      this.setProcessing(true);
      // const collections = ['partner','impact'];
      // this.requests = collections.length;
      // collections.forEach(collection => {
      //   this.fetchCollection(collection).then((res) => {
      //     this.requests--;
      //     this[collection] = res;
      //     this.localStore(collection,res);
      //     if (!this.requests) {
            this.fetchCollection('location').then((res) => {
              const locations = res.filter(loc => !loc.is_local);
              this.localStore('location',locations);
              this.init(locations);
            });
      //     }
      //   });
      // })
    }
  }

  ctrl.fetch();

})(jQuery)